import React from "react";

export default function Sparkline({ data = [], width = 120, height = 36, color = "#7C9C69" }) {
  if (!data || data.length < 2) return <span className="text-[#6E7587] text-xs font-mono">—</span>;
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  const stepX = width / (data.length - 1);
  const points = data
    .map((d, i) => `${(i * stepX).toFixed(1)},${(height - ((d - min) / range) * height).toFixed(1)}`)
    .join(" ");
  const lastUp = data[data.length - 1] >= data[0];
  const stroke = color || (lastUp ? "#7C9C69" : "#C75C5C");
  return (
    <svg width={width} height={height} className="overflow-visible">
      <polyline points={points} fill="none" stroke={stroke} strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  );
}
